import React, { useEffect, useState } from 'react';
import { portalSummary } from '../api';

const fmt = (n: number) => '€' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const ROWS = [
  { key: 'today',      label: 'Today' },
  { key: 'yesterday',  label: 'Yesterday' },
  { key: 'this_week',  label: 'This Week' },
  { key: 'this_month', label: 'This Month' },
  { key: 'last_month', label: 'Last Month' },
  { key: 'this_year',  label: 'This Year' },
  { key: 'last_year',  label: 'Last Year' },
];

export default function Overview() {
  const [summary, setSummary] = useState<any>(null);
  const user = JSON.parse(localStorage.getItem('portal_user') || '{}');

  useEffect(() => {
    portalSummary().then(r => setSummary(r.data));
  }, []);

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>Overview</h2>
      <p style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>
        Lockers: {user.locker_codes?.split(',').join(', ')}
      </p>

      {/* KPI Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 24 }}>
        {[
          { label: 'Today', count: summary?.today?.count, gross: summary?.today?.gross },
          { label: 'This Month', count: summary?.this_month?.count, gross: summary?.this_month?.gross },
          { label: 'This Year', count: summary?.this_year?.count, gross: summary?.this_year?.gross },
        ].map((s, i) => (
          <div key={i} style={{ background: 'white', border: '0.5px solid #e0e0e0', borderRadius: 8, padding: '20px 20px' }}>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 28, fontWeight: 600, color: '#185FA5', marginBottom: 4 }}>{fmt(s?.gross ?? 0)}</div>
            <div style={{ fontSize: 13, color: '#888' }}>{s?.count ?? 0} receipts</div>
          </div>
        ))}
      </div>

      {/* Summary Table */}
      <div style={{ background: 'white', border: '0.5px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8f9fa', borderBottom: '0.5px solid #e0e0e0' }}>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Period</th>
              <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 500, color: '#555' }}>Receipts</th>
              <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 500, color: '#555' }}>Gross Revenue</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row, i) => (
              <tr key={row.key} style={{ borderBottom: '0.5px solid #f0f0f0', background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                <td style={{ padding: '10px 14px' }}>{row.label}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', color: '#444' }}>
                  {summary ? summary[row.key]?.count ?? 0 : '—'}
                </td>
                <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 500 }}>
                  {summary ? fmt(summary[row.key]?.gross ?? 0) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
